module.exports = __webpack_public_path__ + "img/code3.74a406ef.png";